import * as Yup from 'yup';

// \u00C0-\u00CF\u00D0-\u00D6\u00D8-\u00DF\u00E0-\u00EF\u00F0-\u00F6\u00F8-\u00FF
// is the unicode range of special latin characters.
//
// \u00C0-\u00CF => ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏ
// \u00D0-\u00D6 => ÐÑÒÓÔÕÖ
// \u00D8-\u00DF => ØÙÚÛÜÝÞß
// \u00E0-\u00EF => àáâãäåæçèéêëìíîï
// \u00F0-\u00F6 => ðñòóôõö
// \u00F8-\u00FF => øùúûüýþÿ
const rEmail =
    /^[\u00C0-\u00CF\u00D0-\u00D6\u00D8-\u00DF\u00E0-\u00EF\u00F0-\u00F6\u00F8-\u00FF\w0-9.!#$%&'*+/=?^_`{|}~-]+@[\u00C0-\u00CF\u00D0-\u00D6\u00D8-\u00DF\u00E0-\u00EF\u00F0-\u00F6\u00F8-\u00FF\w0-9](?:[\u00C0-\u00CF\u00D0-\u00D6\u00D8-\u00DF\u00E0-\u00EF\u00F0-\u00F6\u00F8-\u00FF\w0-9-_]{0,61}[\u00C0-\u00CF\u00D0-\u00D6\u00D8-\u00DF\u00E0-\u00EF\u00F0-\u00F6\u00F8-\u00FF\w0-9])?(?:\.[\w0-9](?:[\w0-9-]{0,61}[\w0-9])?)*$/;

function isValidEmail(email: string): boolean {
    if (!email?.length) {
        return false;
    }

    if (email.includes(' ')) {
        return false;
    }

    const emailArr = email.split('@');
    if (emailArr.length !== 2) {
        return false;
    }

    const localPart = emailArr[0];
    if (!IsEmailLocalPartValid(localPart)) {
        return false;
    }

    const domainPart = emailArr[1];
    if (!IsEmailDomainPartValid(domainPart)) {
        return false;
    }

    return rEmail.test(email);
}

function IsEmailLocalPartValid(localPart: string): boolean {
    const localArr = localPart.split('.');
    for (const partIndex in localArr) {
        const part = localArr[partIndex];
        if (!part?.length) {
            return false;
        }
    }
    return true;
}

function IsEmailDomainPartValid(domainPart: string): boolean {
    const domainArr = domainPart.split('.');
    if (domainArr.length < 2) {
        return false;
    }

    for (const partIndex in domainArr) {
        const part = domainArr[partIndex];
        if (!part?.length) {
            return false;
        }
    }

    if (domainArr[domainArr.length - 1].length < 2) {
        return false;
    }

    return true;
}

function yupEconomicSpecificEmail() {
    // eslint-disable-next-line no-template-curly-in-string
    return Yup.string().test('economicSpecificEmail', '${path} must be a valid email', value => !value || isValidEmail(value));
}

export { isValidEmail, yupEconomicSpecificEmail };
